import { lazy } from 'react';

const Error500 = lazy(() => import('pages/maintenance/error/500'));

const ErrorRoutes = {
  path: '/maintenance/error/500',
  element: <Error500 />
};

export default ErrorRoutes;
